import type { FaireProductEntity } from "../../entity_types/product";

export const p_ngvhmsdzd7: FaireProductEntity = {
  token: "p_ngvhmsdzd7",
  type: "product",
  name: "Bulk Lotion Bar - Case of 10 | Zero Waste Solid Skincare Refill",
  brandToken: "b_34jwv28ejh",
  brandName: "Zerra & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f02b7ec68836e0c8d2df4711cd3f660d4fabe0b1177ce70306574d5e9bb060f3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/079e7da5c82ff65b820b7e46b5ccbdc26572d7dcfa42685e632f0aacecc184f2.jpeg",
    "https://cdn.faire.com/fastly/b4ecf0ef7d5ccb4c6cc70c8ef1c61c737ca65168e0f92d72e53e339b480bd526.jpeg",
    "https://cdn.faire.com/fastly/352b6f6b9fb6c7906082e32d0bca4aaf9dc6515e5f01420caf3a6b9d0986570f.jpeg",
    "https://cdn.faire.com/fastly/3c96e5202009b64ad4394925bba3097b2a8830bffcebfe2416f22e69a60f729f.jpeg",
    "https://cdn.faire.com/fastly/4b27156e8d236a2ca91d455c35be59553a4066fecfd1b7582e995b78ff12db19.jpeg",
  ],
  priceDollars: 85,
  description:
    "Want to try a free sample? Send us a message!\n\nMeet our waterless and plastic free Lotion Bars! These lotion bars are a great zero waste swap for traditional liquid lotion. Each bar replaces up to 32 fl oz of liquid lotion.\n\nThese are a fantastic stocking stuffer and are a fall/winter skin care staple!\n\nMade mostly from shea butter for deep, nourishing hydration with mango butter for a touch go luxury hydration. Cetyl alcohol gives this bar a silky application while triglycerides keep it light and non-greasy. Together they make a bar that gives decadent hydration without the heavy, greasy skin feel most lotion bars and body salves have.\n\nTo use warm in hands for a few seconds and then apply. Melts with body heat, and stays solid up to 95-100 F.\n\nThis listing is for one case of 10 unpackaged, individual bars in a box. This is not intended to be sold to consumers in a 10 pack.\n\nKey Features\n- Vegan and Cruelty Free\n- Coconut Free\n- Plastic Free\n- Zero Waste\n\nEach bar is 2.3 oz (65 g)",
  tags: [],
  msrpDollars: 170,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:29.071Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
